import type {
  LabelData,
  LabelDataResponse,
  LabelHierarchyResponse,
} from '../types';

// @TODO WMG1-678 - Move to shared location for roster and user management.
export const getLabels = async ({
  name = '',
  limit,
  offset = 0,
}: {
  name?: string;
  limit?: number;
  offset?: number;
} = {}) => {
  try {
    const params = new URLSearchParams();

    if (name) {
      params.set('name', name);
    }

    if (limit) {
      params.set('limit', `${limit}`);
    }

    if (offset) {
      params.set('offset', `${offset}`);
    }

    const response = await fetch(
      `/api/music_api/v1/labels?${params.toString()}`,
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch labels: ${response.statusText}`);
    }

    const data: LabelDataResponse = await response.json();

    return data.items.map((item) => {
      const lastRoster = item.rosters?.find(
        (roster) => roster.roster_type === 1,
      );

      return {
        labelId: item.label_id,
        name: item.name,
        updatedAt: lastRoster?.updated_at ?? '',
        updatedBy: lastRoster?.updated_by ?? '',
      } as LabelData;
    });
  } catch (error) {
    console.error('Error fetching labels:', error);

    throw error;
  }
};

export const getLabelHierarchy = async (
  hasRosters = true,
): Promise<LabelHierarchyResponse> => {
  try {
    const response = await fetch(
      '/api/music_api/v1/label-hierarchies?has_rosters=' + hasRosters,
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch labels: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching labels:', error);

    throw error;
  }
};
